import { produce } from "immer";
import * as Actions from "pages/Settings/MultiFactorAuth/store/mfaActions";

const initialState = {
  isLoading: false,
  errorMessage: null,
  items: []
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCHING: {
      draft.isLoading = true;
      break;
    }

    case Actions.SET_ERROR_MESSAGE: {
      draft.isLoading = false;
      draft.errorMessage = action.payload;
      break;
    }

    case Actions.FETCH_SUCCESS: {
      draft.isLoading = false;
      draft.errorMessage = null;
      draft.items = action.payload;

      break;
    }

    case Actions.RESET: {
      return {
        ...initialState
      };
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
